import { resolveFilterFieldComponent } from './filterFieldRegistry';

/**
 * Dispatches to the appropriate field renderer (Single Responsibility — routing only).
 */
const FilterField = (props) => {
  const Component = resolveFilterFieldComponent(props.field);
  return <Component {...props} />;
};

export default FilterField;
